var globalbuildwebBridge;

(function () {
  var t = {
    port: "33103",
    url: "https://local-sso.longfor.com:"
  },
      a = function a(t, _a, o) {
    var e = document.createElement("script");
    e.type = "text/javascript", e.readyState ? e.onreadystatechange = function () {
      "loaded" !== e.readyState && "complete" !== e.readyState || (e.onreadystatechange = null, _a(o));
    } : e.onload = function () {
      _a(o);
    }, e.src = t, document.getElementsByTagName("head")[0].appendChild(e);
  },
      o = function o(_o) {
    -1 === window.location.host.indexOf("longfor.com") && (t.url = "https://local-sso.longhu.net:");

    for (var e = ["33103", "33104", "33105", "33106", "33107", "33108"], n = 0; n < e.length; n++) {
      var l = t.url + e[n] + "/localhosttoken/jsmap?callback=allCallBackByPc&env=" + _o;
      a(l, function (a) {
        t.port = a;
      }, e[n]);
    }
  },
      e = function e(o) {
    var e = t.url + t.port + "/localhosttoken/jsmap?callback=allCallSso&env=" + o;
    a(e, function () {});
  };

  window.currentPcConnectParameter = t, window.createScrptByPc = a, window.startLinkInitPc = o, window.getSsoAuth = e, globalbuildwebBridge = {};
})();